import Link from 'next/link'
import classNames from 'classnames'
import styled from 'styled-components'
import ArrowRightSLineIcon from 'remixicon-react/ArrowRightSLineIcon'
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon'
import CheckboxCircleFillIcon from 'remixicon-react/CheckboxCircleFillIcon'

import {styledTheme} from '@festi/common/themes'

const Root = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  color: white;
`
const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &.hasLink {
    padding-bottom: 16px;
  }
`

const Text = styled.div`
  color: white;
`

const Line = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
  opacity: 0.25;
  background-color: white;
`

const ToastLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: white;
  width: 100%;
  padding-top: 16px;
  cursor: pointer;
`

interface Props {
  message: string
  icon?: 'error' | 'success'
  link?: string
  linkText?: string
}

export function CustomToast({message, link, linkText, icon}: Props) {
  const hasLink = !!link

  const Icon = {
    error: <ErrorWarningFillIcon color={styledTheme.palette.error} />,
    success: <CheckboxCircleFillIcon color={styledTheme.palette.success} />,
  }

  return (
    <Root>
      <TextWrapper className={classNames({hasLink})}>
        {!!icon && Icon[icon]}
        <Text>{message}</Text>
      </TextWrapper>

      {hasLink && (
        <>
          <Line />

          <ToastLink href="/karfa">
            <span>{linkText || 'Link Text'}</span>
            <ArrowRightSLineIcon />
          </ToastLink>
        </>
      )}
    </Root>
  )
}
